import * as Projects from "@/models/projects";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router";

import { Forms } from "turboui";
import { SubscriptionsState } from "@/models/subscriptions";
import { emptyContent, isContentEmpty } from "turboui";

import { usePaths } from "@/routes/paths";

interface UseFormProps {
  project: Projects.Project;
  subscriptionsState: SubscriptionsState;
}

export function useForm({ project, subscriptionsState }: UseFormProps) {
  const { t } = useTranslation();
  const paths = usePaths();
  const navigate = useNavigate();
  const createDiscussion = Projects.useCreateProjectDiscussion();

  const form = Forms.useForm({
    fields: {
      title: "",
      message: emptyContent(),
    },
    validate: (addError) => {
      if (isContentEmpty(form.values.message)) {
        addError("message", t("Body is required"));
      }
    },
    submit: async () => {
      const res = await createDiscussion.mutateAsync({
        projectId: project.id,
        title: form.values.title,
        message: JSON.stringify(form.values.message),
        sendNotificationsToEveryone: subscriptionsState.notifyEveryone,
        subscriberIds: subscriptionsState.currentSubscribersList,
      });

      navigate(paths.projectDiscussionPath(res.discussion.id!));
    },
  });

  return form;
}
